<template>
  <div>
    <section>
      <header>
        <div class="headerLeft flexAndCenter">
          <div style="margin-right: 24px">
            <el-input v-model="data.searchText" :placeholder="$t('message.rolename')" />
          </div>
          <!--角色名-->
          <div>
            <el-select v-model="data.workType" :placeholder="$t('message.typeOfWork')"><!--工种-->
              <el-option v-for="item in worktypeData" :key="item.id" :label="item.work_name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!--姓名-->
          <el-button @click="search" type="primary" style="margin: 0 16px 0 40px">{{ $t("message.search")
            }}</el-button><!--搜索-->
          <el-button @click="reset">{{ $t("message.reset") }}</el-button><!--重置-->
        </div>
        <div><!--批量调整权限-->
          <el-button size="small" type="success" @click="$router.push('/batchAdjustPermissions')">{{
              $t("message.batchAdjustPermissions") }}
          </el-button>
          <!--新增角色-->
          <el-button icon="el-icon-plus" size="small" @click="$router.push('addRole')" type="primary"
            v-if="isAuth(128)">{{
              $t("message.theNewRole") }}
          </el-button>
        </div>
      </header>
      <div class="table">
        <el-table :data="roleList" style="width: 100%" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }">
          <el-table-column type="index" label="NO" align="center">
          </el-table-column>
          <!--      角色名称-->
          <el-table-column prop="name" :label="$t('message.characterName')" align="center">
          </el-table-column>
          <!--      工种-->
          <el-table-column :label="$t('message.typeOfWork')" align="center" prop="work_type.work_name">
          </el-table-column>
          <!--      组织-->
          <el-table-column prop="organization.name" :label="$t('message.organization')" align="center">
          </el-table-column>
          <!--操作-->
          <el-table-column label="操作" align="center" width="600">
            <template v-slot="scope">

              <el-button size="mini" @click="setRoleAuth(scope.row)" style="background: #2c96e7; color: #fff"
                v-if="isAuth(131)">{{
              $t("message.rolePermission") }}</el-button><!--角色权限-->
              <el-button size="mini" @click="editRole(scope.row)" style="background: #15ad3c; color: #fff"
                v-if="isAuth(129)">{{
              $t("message.redact") }}</el-button><!--编辑-->
              <el-button size="mini" @click="roleDelete(scope.row)" style="background: #333333; color: #fff"
                v-if="isAuth(130)">{{
              $t("message.delete") }}</el-button><!--删除-->
              <el-button size="mini" @click="japaneseOffice(scope.row)" style="background: #2c96e7; color: #fff"
                v-if="isAuth(131)">{{
              $t("message.japaneseOffice") }}</el-button><!--日本事务所-->
              <el-button type="success" @click="roleAllotAuth(scope.row)" size="mini"> 编辑关闭角色的分配权限</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="data.page"
          :page-sizes="[10, 20, 30, 40]" :page-size="data.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </section>
    <!-- 编辑 关闭角色的分配权限 -->
    <el-dialog title="编辑 关闭角色的分配权限" :close-on-click-modal="false" :visible.sync="dialogVisible" width="780px" center>
      <div class="authList">
        <el-checkbox v-model="item.checked" v-for="(item, index) in authList" :key="index">{{ item.name }}</el-checkbox>
      </div>

      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
              $t("message.cancel")
            }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="setRoleAllotAuth">{{
              $t("message.ok")
            }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>

export default {

  name: "index",
  data() {
    return {
      data: {
        searchText: "",
        workType: "",
        page: 1,
        pageSize: 10,
      },
      worktypeData: [],
      roleList: [],
      total: 0,
      // 关闭角色的分配权限
      dialogVisible: false,
      authList: [],
      role_id: ''
    };
  },
  created() {
    this.getRoleList();
    this.getWorktypeList();
    this.$api.roleApi.getRoleAllotAuth().then(res => {
      res.data.forEach(item => {
        item.checked = false
      })
      this.authList = res.data;
    })
  },
  methods: {
    getRoleList() {
      this.$api.roleApi.roleList(this.data).then((res) => {
        this.roleList = res.data.data;
        this.total = res.data.total;
      });
    },
    //更新页数
    handleCurrentChange(val) {
      this.data.page = val;
      this.getRoleList();
    },
    //更新分页每页数量
    handleSizeChange(val) {
      this.data.pageSize = val;
      this.getRoleList();
    },
    //编辑角色页面跳转
    editRole(item) {
      this.$router.push({
        name: "addRole",
        query: {
          id: item.id,
          searchText: item.name,
          workType: item.work_type.work_type,
          auto_chat: item.auto_chat,
        },
      });
    },
    //角色权限
    setRoleAuth(item) {
      this.$store.commit("setRoleAuth", item.auth);
      this.$router.push("/setRoleAuth?id=" + item.id + "&name=" + item.name);
    },
    //工种类型获取
    getWorktypeList() {
      this.$api.roleApi.worktypeList().then((res) => {
        this.worktypeData = res.data;
      });
    },
    //删除角色
    roleDelete(item) {
      //是否删除该角色                           提示
      this.$confirm(
        this.$t("message.whetherToDeleteTheRole"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.confirm"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.roleApi
            .roleDelete({
              id: item.id,
            })
            .then((res) => {
              this.$message.success(res.msg);
              this.getRoleList();
            });
        })
        .catch((err) => {
          this.$message({
            type: "info",
            message: this.$t("message.theDeletionHasBeenCancelled"), //已取消删除
          });
        });
    },
    search() {
      this.data.page = 1;
      this.getRoleList();
    },
    reset() {
      this.data = {
        searchText: "",
        workType: "",
        page: 1,
        pageSize: 10,
      };
      this.getRoleList();
    },
    //日本事务所
    japaneseOffice(item) {
      this.$router.push('/jurisdiction?role_id=' + item.id)
    },
    // 编辑关闭角色的分配权限
    roleAllotAuth(row) {
      this.role_id = row.id
      this.authList.forEach(item => {
        item.checked = false
        row.role_auth_allot_client.forEach(items => {
          if (item.id == items.client_attribute_id) {
            item.checked = true
          }
        })
      })
      this.dialogVisible = true

    },
    //关闭角色的分配权限
    setRoleAllotAuth() {
      let datas = {
        list: [{
          role_id: this.role_id,
          client_attribute_id: []
        }]
      }
      this.authList.forEach(item => {
        if (item.checked) {
          datas.list[0].client_attribute_id.push(
            item.id
          )
        }
      })
      this.$api.roleApi.setRoleAllotAuth(datas).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.getRoleList()
      })
    },

  },
};
</script>

<style lang="scss" scoped>
.flexAndCenter {
  display: flex;
  align-items: center;
}

section {
  border-radius: 8px;
  background: #f8f8f8;
  display: flex;
  flex-direction: column;
  padding: 24px;

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .table {
    margin-top: 24px;
  }
}

.authList {
  padding: 20px 50px;
}
</style>